module.exports = __webpack_public_path__ + "img/serviceImg2.0ab6e4db.png";